module.exports = __webpack_public_path__ + "img/1537668223.90ae3720.jpg";